import { useTranslation } from "react-i18next";
import { Sparkles } from "lucide-react";

import type { RailStarter } from "./rail-starter";

interface Props {
  starters: RailStarter[];
  /** Prefill the composer with the starter's prompt (user still sends it). */
  onPick: (prompt: string) => void;
}

/**
 * The empty-rail state (4b): three generated starters drawn from what is on
 * screen, so a permanent-but-empty rail is never blank. Cards prefill the
 * composer rather than sending, matching the page starters.
 */
export function RailStarterList({ starters, onPick }: Props) {
  const { t } = useTranslation("intelligence");

  return (
    <div className="flex flex-col gap-2">
      <div className="mb-1 flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.06em] text-muted-foreground">
        <Sparkles className="size-3.5 text-primary" />
        {t("rail.starters.heading")}
      </div>
      {starters.map((starter) => {
        const Icon = starter.icon;
        return (
          <button
            key={starter.id}
            type="button"
            onClick={() => onPick(starter.prompt)}
            className="group flex w-full items-start gap-3 rounded-[11px] border border-border bg-background p-[11px_12px] text-left transition-colors hover:border-primary/30 hover:bg-primary/5"
          >
            <span className="mt-0.5 flex size-[26px] shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
              <Icon className="size-[15px]" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="block text-[13px] font-semibold leading-snug text-foreground">
                {starter.title}
              </span>
              <span className="mt-0.5 block text-[11.5px] leading-snug text-muted-foreground">
                {starter.reason}
              </span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
